document.addEventListener('DOMContentLoaded', function() {
  // Find all FAQ sections
  const faqSections = document.querySelectorAll('.faqs');
  
  faqSections.forEach(function(section) {
    // Find FAQ items within this specific section
    const faqItems = section.querySelectorAll('.faq-item');
    
    faqItems.forEach(function(item) {
      const title = item.querySelector('.faq-item-title');
      const content = item.querySelector('.faq-item-content');
      
      if (title && content) {
        // Add click event to title
        title.addEventListener('click', function() {
          const isActive = item.classList.contains('active');
          
          if (isActive) {
            // Close this item
            closeAccordionItem(item, content);
          } else {
            // Close all other items in THIS SECTION only (not other sections)
            faqItems.forEach(function(otherItem) {
              if (otherItem !== item && otherItem.classList.contains('active')) {
                const otherContent = otherItem.querySelector('.faq-item-content');
                closeAccordionItem(otherItem, otherContent);
              }
            });
            
            // Open this item
            openAccordionItem(item, content);
          }
        });
        
        // Set initial state - all closed by default
        content.style.maxHeight = '0';
        content.style.overflow = 'hidden';
      }
    });
  });
  
  function openAccordionItem(item, content) {
    item.classList.add('active');
    content.style.maxHeight = content.scrollHeight + 'px';
  }
  
  function closeAccordionItem(item, content) {
    item.classList.remove('active');
    content.style.maxHeight = '0';
  }
});